var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/VirtualStandardSizeWithSum.tsx";
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function VirtualStandardSizeWithSum({
  color = '#353B60',
  secondaryColor = '#AFB3C0',
  opacity = '0.25',
  ...other
}) {
  return /*#__PURE__*/_jsxs("svg", {
    width: "25",
    height: "24",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_6946_147279)",
      children: [/*#__PURE__*/_jsx("rect", {
        x: "1.98694",
        y: "1",
        width: "22",
        height: "22",
        rx: "3",
        stroke: color,
        strokeOpacity: "0.15",
        strokeWidth: "2"
      }), /*#__PURE__*/_jsx("path", {
        opacity: opacity,
        d: "M13.9869 7C13.9869 6.44772 14.4347 6 14.9869 6H18.9869C19.5392 6 19.9869 6.44772 19.9869 7V17C19.9869 17.5523 19.5392 18 18.9869 18H14.9869C14.4347 18 13.9869 17.5523 13.9869 17V7Z",
        fill: color
      }), /*#__PURE__*/_jsx("circle", {
        cx: "19.9865",
        cy: "19",
        r: "5.5",
        fill: secondaryColor,
        stroke: "white"
      }), /*#__PURE__*/_jsx("path", {
        d: "M21.9864 17L21.9864 16.7C21.9864 16.5895 21.8969 16.5 21.7864 16.5L18.6106 16.5C18.3591 16.5 18.2192 16.791 18.3764 16.9874L19.9864 19L18.3764 21.0126C18.2192 21.209 18.3591 21.5 18.6106 21.5L21.7864 21.5C21.8969 21.5 21.9864 21.4105 21.9864 21.3L21.9864 21",
        stroke: "white",
        strokeWidth: "1.4",
        strokeLinecap: "round"
      }), /*#__PURE__*/_jsx("rect", {
        opacity: opacity,
        x: "5.98694",
        y: "12",
        width: "6",
        height: "6",
        rx: "1",
        fill: color
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_6946_147279",
        children: /*#__PURE__*/_jsx("rect", {
          width: "24",
          height: "24",
          fill: "white",
          transform: "translate(0.986938)"
        })
      })
    })]
  });
}